import { useMutation } from '@tanstack/react-query';
import {
  createGatewayConversionSettings,
  CreateGatewayConversionSettingsParams,
} from 'config/requests/orderConversion';

export function useCreateGatewayConversionSettings() {
  const mutation = useMutation({
    mutationFn: (data: CreateGatewayConversionSettingsParams) =>
      createGatewayConversionSettings(data),
  });

  return { createGatewayConversionSettings: mutation };
}
